import { ColumnSelectorComponent } from './column-selector/column-selector.component';
import { TableComponent } from './table/table.component';
import { TableBarComponent } from './table-bar/table-bar.component';
import { TableCellComponent } from './table-cell/table-cell.component';
import { TableHeaderComponent } from './table-header/table-header.component';

export const Components = [
	ColumnSelectorComponent,
	TableComponent,
	TableBarComponent,
	TableCellComponent,
	TableHeaderComponent,
];
